module.exports = __webpack_public_path__ + "static/media/ask_caryn icon.654b7a06.svg";